import { Checkbox, message } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTermsAndConditionHandler, getTermsAndConditionSliceAction } from "../../redux/action/guestUserAction/getTermsAndCondition";
import { acceptTermsAndConditionHandler, acceptTermsAndConditionSliceAction } from "../../redux/action/guestUserAction/acceptTermsAndCondition";
import { STATUS_CODE } from "../../common";
import { GUEST_ENROLLMENT_PATHS } from "../../common/guestEnrollmentFlow";
import NoDataAvailableState from "./NoDataAvailableState";
import EducationalContentHeader from "./EducationalContentHeader";
import Loader from "../Loder/loader";

const TermsOfUseAndCondition = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);

  const getTermsAndConditionSelector = useSelector((state) => state?.getTermsAndCondition);
  const acceptTermsAndConditionSelector = useSelector(
    (state) => state?.acceptTermsAndCondition,
  );
  useEffect(() => {
    dispatch(getTermsAndConditionHandler());
  }, [dispatch]);
  const htmlContent = getTermsAndConditionSelector?.data?.data?.content?.htmlContent;
  const termsAndConditionId = getTermsAndConditionSelector?.data?.data?.id;
  const termsStatusCode = getTermsAndConditionSelector?.data?.statusCode;
  const termsErrorStatusCode = getTermsAndConditionSelector?.message?.statusCode;
  const hasTermsResponse = termsStatusCode != null || termsErrorStatusCode != null;
  const shouldShowLoader =
    getTermsAndConditionSelector?.isLoading || !hasTermsResponse;
  const showNoDataState =
    !shouldShowLoader &&
    (termsErrorStatusCode === STATUS_CODE.NOT_FOUND ||
      termsStatusCode !== STATUS_CODE.OK ||
      !htmlContent);


  const isValidExternalLink = (href = "") => {
    try {
      const parsedUrl = new URL(href);
      return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
    } catch (error) {
      return false;
    }
  };

  const handleTermsLinkClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const anchorElement = event.target.closest("a");
    if (!anchorElement) return;

    event.preventDefault();
    const href = anchorElement.getAttribute("href")?.trim();

    if (!href || !isValidExternalLink(href)) {
      message.error(t("This document link is no longer available."));
      return;
    }

    window.open(href, "_blank", "noopener,noreferrer");
  };

  const handleAccept = async () => {
    if (!isChecked || acceptTermsAndConditionSelector?.isLoading) return;

    try {
      const response = await dispatch(acceptTermsAndConditionHandler({
        id: termsAndConditionId
      }));
      if (response?.statusCode === STATUS_CODE.OK) {
        navigate("/guest-user/welcome", {
          state: { guestEducationalBackTo: GUEST_ENROLLMENT_PATHS.terms },
        });
      }
    } catch (e) {
      console.error("Failed to accept terms & conditions", e);
    }
    finally {
      dispatch(acceptTermsAndConditionSliceAction.acceptTermsAndConditionReset());
      dispatch(getTermsAndConditionSliceAction.getTermsAndConditionSliceReset());
    }
  };

  return (
    <EducationalContentHeader
      title={t("Terms of Use & Condition")}
      hideNavigation
      hideBackButton
    >
      {shouldShowLoader ? (
        <Loader loaderTransForm="loaderTransForm" />
      ) : (
        <div className="container marginTop80 noMobileMargin">
          <div className="mx-600 mx-auto">
            <div className="py-20 text-start w-100">
              {showNoDataState ? (
                <NoDataAvailableState />
              ) : (
                <>
                  <div className="termsOfUseHtmlContainer mb-16">
                    {htmlContent && (
                      <div
                        className="mb-40 fs-16 colorblur lh-20 termsOfUseHtml"
                        onClick={handleTermsLinkClick}
                        dangerouslySetInnerHTML={{ __html: htmlContent }}
                      />
                    )}
                  </div>
                  <div className="d-flex align-start gap-12 mb-40">
                    <Checkbox
                      className="customCheckbox gap4 fs-16 lh-20 p-0"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                    >
                      {t("I have read and agree to the Terms of Use & Condition.")}
                    </Checkbox>
                  </div>
                  {!showNoDataState && (<button
                    className={`primaryButton w-100 mb-40 cursor-pointer fs-18 ${isChecked && !acceptTermsAndConditionSelector?.isLoading
                      ? "activeted"
                      : "disable"
                      }`}
                    onClick={handleAccept}
                    disabled={!isChecked || acceptTermsAndConditionSelector?.isLoading}
                  >
                    {t("Accept & Continue")}
                  </button>)}
                </>
              )}

            </div>
          </div>
        </div>
      )}
    </EducationalContentHeader >
  );
};

export default TermsOfUseAndCondition;
